import React from 'react';
import { getBondsDate } from '@/finsight/ui/components/bonds/helpers';
import { usePositionsContext } from '@/finsight/application/PortfolioMonitor/PositionsContext';

import styles from './styles.scss';

const LastUpdated = () => {
  const {
    positionList,
    lastUpdated,
  } = usePositionsContext();
  return (
      positionList.isInitialized
      && !positionList.isFetching
      && lastUpdated?.timezone
      && (
        <div className={ styles.lastUpdated }>
          { `Last Updated: ${ getBondsDate(lastUpdated, true) }` }
        </div>
      )
  );
};

export default LastUpdated;
